import axios from 'axios'

export const getCategories = (params) =>
    axios.get('categories', params)
        .then(({ data }) => data)

export const getCategoryView = (slug) =>
    axios.get(`categories/${slug}`)
        .then(({ data }) => data)

export const getCategoryCompanies = (slug, params) =>
    axios.get(`categories/${slug}/companies`, params)
        .then(({ data }) => data)
